import { useBrandOf } from '../projects/projectsApi';
import { PlaceholderStack, ProjectStack } from './ProjectStack';
import type { ProjectInfo, ProjectOverview } from './rows';

/** The Home's wrapping shelf of photo pockets. */
export function ProjectChips({ projects, onOpen }: { projects: readonly { summary: ProjectOverview; info: ProjectInfo }[]; onOpen: (id: string) => void }) {
  const brandOf = useBrandOf();
  return (
    <ul className="home-project-grid">
      {projects.map(({ summary, info }) => (
        <li key={summary.projectId}>
          <ProjectStack summary={summary} project={info} brand={brandOf(info.brandId)} onOpen={() => onOpen(summary.projectId)} />
        </li>
      ))}
    </ul>
  );
}

export function PlaceholderChips({ count = 4 }: { count?: number }) {
  return (
    <div aria-hidden className="home-project-grid">
      {Array.from({ length: count }, (_, index) => <PlaceholderStack key={index} />)}
    </div>
  );
}
